// extracted by mini-css-extract-plugin
module.exports = {"starsEmpty":"Stars_starsEmpty__1rL-G","starsFull":"Stars_starsFull__BNHea"};